import { Select } from "antd";

interface ICustomDropdownMultiSelect {
  onChange: (value: any[]) => void;
  options: { label: string; value: any; disabled: boolean }[];
  value: any[];
}

const CustomDropdownMultiSelect = ({
  onChange,
  options,
  value,
}: ICustomDropdownMultiSelect) => (
  <>
    <Select
      mode="multiple"
      style={{ width: "100%" }}
      placeholder="Please select"
      onChange={onChange}
      options={options}
      value={value}
      optionFilterProp="label"
    />
  </>
);

export default CustomDropdownMultiSelect;
